export const methods = {
  update() {
    console.log('update', this.input)

    this.point = this.input
  }
}
